import { INITIAL_AGE, MAX_AGE } from './config';
import { parseNumber } from '../common-helpers';

export const getAgeValues = () => ([
  ...Array.from({ length: MAX_AGE - INITIAL_AGE + 1 }, (_, key) => (key + INITIAL_AGE).toString()),
  `${MAX_AGE + 1}+`,
]);

export const calc = (distributionPeriod: number, balance: number | string) => {

  const parsedBalance: number | string = typeof balance === 'string' ? parseNumber(balance) : balance;

  return parseFloat((Number(parsedBalance) / distributionPeriod).toFixed(2));
};

export const getDistributionPeriod = (age: string) => {
  switch (age) {
    case '72':
      return 27.4;
    case '73':
      return 26.5;
    case '74':
      return 25.5;
    case '75':
      return 24.6;
    case '76':
      return 23.7;
    case '77':
      return 22.9;
    case '78':
      return 22.0;
    case '79':
      return 21.1;
    case '80':
      return 20.2;
    case '81':
      return 19.4;
    case '82':
      return 18.5;
    case '83':
      return 17.7;
    case '84':
      return 16.8;
    case '85':
      return 16.0;
    case '86':
      return 15.2;
    case '87':
      return 14.4;
    case '88':
      return 13.7;
    case '89':
      return 12.9;
    case '90':
      return 12.2;
    case '91':
      return 11.5;
    case '92':
      return 10.8;
    case '93':
      return 10.1;
    case '94':
      return 9.5;
    case '95':
      return 8.9;
    case '96':
      return 8.4;
    case '97':
      return 7.8;
    case '98':
      return 7.3;
    case '99':
      return 6.8;
    case '100':
      return 6.4;
    case '101':
      return 6.0;
    case '102':
      return 5.6;
    case '103':
      return 5.2;
    case '104':
      return 4.9;
    case '105':
      return 4.6;
    case '106':
      return 4.3;
    case '107':
      return 4.1;
    case '108':
      return 3.9;
    case '109':
      return 3.7;
    case '110':
      return 3.5;
    case '111':
      return 3.4;
    case '112':
      return 3.3;
    case '113':
      return 3.1;
    case '114':
      return 3.0;
    case '115':
      return 2.9;
    case '116':
      return 2.8;
    case '117':
      return 2.7;
    case '118':
      return 2.5;
    case '119':
      return 2.3;
    case '120+':
      return 2.0;
    default:
      return 0;
  }
};
